(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beautygram-b2b-benefits-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const popup = document.querySelector('[data-benefits-popup]');
    if (!popup || !window.HTMLDialogElement) return;
    const key = 'beautygram-b2b-benefits-popup-seen';
    const close = () => {
      if (popup.open) popup.close();
      sessionStorage.setItem(key, 'true');
    };
    popup.querySelector('[data-popup-close]')?.addEventListener('click', close);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) close();
    });
    popup.addEventListener('cancel', (event) => {
      event.preventDefault();
      close();
    });
    if (Shopify.designMode || !sessionStorage.getItem(key)) {
      window.setTimeout(() => {
        if (!popup.open) popup.showModal();
      }, Number(popup.dataset.delay || 6000));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beautygram-quick-order"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('beautygram-quick-order')) {
    customElements.define('beautygram-quick-order', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.catalog = [];
        this.maskOnly = this.dataset.maskOnly === 'true';
        this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
        this.testerProgress = JSON.parse(this.querySelector('[data-tester-progress]').textContent || 'null');
        this.quantities = new Map(); this.page = 1; this.pageSize = 20; this.busy = false;
        const searchParams = new URLSearchParams(location.search);
        this.brand = searchParams.get('brand') || '';
        this.package = searchParams.get('package') || '';
        this.initialPlacementUsed = this.dataset.initialPlacementUsed === 'true';
        if (this.initialPlacementUsed && this.package !== 'custom') this.package = '';
        this.query = ''; this.stockOnly = false;
        this.money = n => new Intl.NumberFormat('el-GR', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(n / 100);
        this.loadLiveCatalog();
        this.querySelectorAll('[data-brand]').forEach(b => b.addEventListener('click', () => {
          this.brand = b.dataset.brand; this.page = 1; this.render();
          const url = new URL(location.href); this.brand ? url.searchParams.set('brand', this.brand) : url.searchParams.delete('brand'); history.replaceState(null, '', url);
        }));
        this.querySelector('[data-search]').addEventListener('input', e => {this.query = e.target.value.toLocaleLowerCase().trim(); this.page = 1; this.render();});
        this.querySelector('[data-stock]').addEventListener('change', e => {this.stockOnly = e.target.checked; this.page = 1; this.render();});
        this.querySelector('[data-prev]').addEventListener('click', () => {if(this.page>1){this.page--;this.render();}});
        this.querySelector('[data-next]').addEventListener('click', () => {if(this.page<this.pages){this.page++;this.render();}});
        this.querySelector('[data-clear]').addEventListener('click', () => {this.quantities.clear();this.render();});
        this.querySelector('[data-add]').addEventListener('click', () => this.add());
        this.render();
      }
      canonicalBrand(p) {
        const normalize = value => String(value || '').normalize('NFKD').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
        const title = normalize(p.title), type = normalize(p.productType), vendor = normalize(p.vendor);
        const brands = [
          ['Beauty of Joseon', /beauty of joseon/], ['Dr. Althea', /dr althea/],
          ['Some By Mi', /some by mi|somebymi/], ['Mary & May', /mary and may|mary may|marymay/],
          ['K-Secret Seoul 1988', /k secret/], ['Round Lab', /round lab/],
          ['When Beauty', /when beauty|^when |^simply when /], ["It's Skin", /it s skin|itsskin/],
          ['Petitfee & Koelf', /petitfee|koelf/],
          ...['Anua','COSRX','Biodance','Medicube','SKIN1004','Celimax','Tocobo','Purito','APLB','Jigot','Farmstay','Mizon','Nature Republic','Missha'].map(name => [name, new RegExp(name.toLowerCase())])
        ];
        return brands.find(([,pattern]) => pattern.test(title))?.[0]
          || brands.find(([,pattern]) => pattern.test(type))?.[0]
          || brands.find(([,pattern]) => pattern.test(vendor))?.[0]
          || p.vendor || '';
      }
      isMask(p) {
        return /mask|masque|patch|sleeping pack|μάσκ|μασκ|hydrogel/i.test([p.title,p.productType].join(' '))
          || p.brand === 'When Beauty';
      }
      async loadLiveCatalog() {
        const message = this.querySelector('[data-message]');
        if (message && this.dataset.enabled === 'true') message.textContent = 'Φόρτωση διαθέσιμων προϊόντων…';
        try {
          const loadPage = async page => {
            const url = new URL(this.dataset.root + 'collections/all', location.origin);
            url.searchParams.set('section_id', 'beautygram-catalog-feed');
            url.searchParams.set('page', String(page));
            const previewThemeId = new URLSearchParams(location.search).get('preview_theme_id');
            if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
            const response = await fetch(url, {headers: {Accept: 'text/html'}, credentials: 'same-origin'});
            if (!response.ok) throw new Error('Catalog response ' + response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const data = doc.querySelector('[data-beautygram-catalog-feed]');
            if (!data) throw new Error('Catalog feed unavailable');
            return JSON.parse(data.textContent);
          };
          const first = await loadPage(1);
          if (!first.pages) throw new Error('Catalog feed unavailable');
          const rest = await Promise.all(Array.from({length:first.pages-1},(_,i)=>loadPage(i+2)));
          const unique = new Map();
          for (const raw of [first,...rest].flatMap(page=>page.items)) {
            const p = {...raw, id:String(raw.id), price:Number(raw.price)||0, stock:Math.max(0,Number(raw.stock)||0), preorder:raw.preorder === true};
            p.brand = this.canonicalBrand(p);
            if (p.variantTitle && p.variantTitle !== 'Default Title') p.title += ' · ' + p.variantTitle;
            if (this.maskOnly && !this.isMask(p)) continue;
            unique.set(p.id,p);
          }
          this.catalog = [...unique.values()];
          this.catalogLoaded = true;
          this.querySelectorAll('[data-brand]').forEach(button => {
            if (button.dataset.brand) button.hidden = !this.catalog.some(p=>p.brand===button.dataset.brand);
          });
          if (!this.catalog.some(p=>p.brand===this.brand)) this.brand='';
          this.applyPackagePreset();
          if (message && this.dataset.enabled === 'true') message.textContent = '';
          this.render();
        } catch(error) {
          if (message) message.textContent = this.copy.loadError || 'Δεν φορτώθηκε ο κατάλογος. Ανανεώστε τη σελίδα.';
          this.querySelector('[data-add]').disabled = true;
        }
      }
      applyPackagePreset() {
        if (this.maskOnly || !this.package) return;
        if (this.package === 'custom') {
          const benefit = this.querySelector('[data-custom-benefit]');
          if (benefit) benefit.hidden = false;
          return;
        }
        const plans = {
          discovery: {label: 'Discovery', target: 49900, brands: ['Beauty of Joseon','Anua','SKIN1004'], maxEach: 3, codes: 18},
          signature: {label: 'Signature', target: 99900, brands: ['Medicube','Dr. Althea','Biodance'], maxEach: 4, codes: 28},
          complete: {label: 'Complete', target: 199900, brands: ['Beauty of Joseon','Anua','COSRX','Dr. Althea','Biodance','Medicube','SKIN1004','Celimax','Tocobo','Round Lab','Some By Mi','Purito','APLB','Petitfee & Koelf','K-Secret Seoul 1988','Mary & May'], maxEach: 6, codes: 45}
        };
        const plan = plans[this.package];
        if (!plan) return;
        const brandGroups = plan.brands.map(brand => this.catalog.filter(product => product.brand === brand && product.stock >= 3 && product.price > 0));
        const longestGroup = Math.max(...brandGroups.map(group => group.length));
        const candidates = Array.from({length: longestGroup}, (_, index) => brandGroups.map(group => group[index]).filter(Boolean)).flat().slice(0, plan.codes);
        let total = 0;
        for (const product of candidates) {
          if (total + product.price * 3 > plan.target) continue;
          this.quantities.set(product.id, 3);
          total += product.price * 3;
        }
        while (total < plan.target) {
          const available = candidates.filter(product => this.quantities.has(product.id) && (this.quantities.get(product.id) || 0) < Math.min(product.stock, plan.maxEach));
          if (!available.length) break;
          const fitting = available.find(product => total + product.price <= plan.target);
          const next = fitting || available.reduce((smallest, product) => product.price < smallest.price ? product : smallest);
          this.quantities.set(next.id, (this.quantities.get(next.id) || 0) + 1);
          total += next.price;
        }
        const notice = this.querySelector('[data-package-notice]');
        if (notice) {
          notice.textContent = notice.textContent.replace('__PACKAGE__', plan.label);
          notice.hidden = false;
        }
      }
      el(tag, cls, value) {const el=document.createElement(tag); if(cls)el.className=cls;if(value!==undefined)el.textContent=value;return el;}
      render() {
        this.querySelectorAll('[data-brand]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.brand === this.brand)));
        const filtered=this.catalog.filter(p=>(!this.brand||p.brand===this.brand)&&(!this.stockOnly||p.stock>0)&&(!this.query||[p.title,p.sku,p.barcode,p.brand].join(' ').toLocaleLowerCase().includes(this.query)));
        this.pages=Math.max(1,Math.ceil(filtered.length/this.pageSize));this.page=Math.min(this.page,this.pages);
        const rows=this.querySelector('[data-rows]');rows.replaceChildren();
        this.querySelector('[data-results]').textContent=filtered.length+' '+this.copy.codes;
        if(!filtered.length)rows.append(this.el('p','bg-qo__empty',this.copy.empty));
        filtered.slice((this.page-1)*this.pageSize,this.page*this.pageSize).forEach(p=>{
          const row=this.el('div','bg-qo__row');row.dataset.id=p.id;
          const product=this.el('div','bg-qo__product');
          if(p.image){const img=this.el('img');img.src=p.image;img.alt='';img.loading='lazy';img.width=62;img.height=72;product.append(img);}
          const body=this.el('div','bg-qo__product-content');body.append(this.el('div','bg-qo__brand',p.brand),this.el('h2','',p.title),this.el('div','bg-qo__sku','SKU: '+(p.sku||p.barcode||'—')));
          const progress=this.testerProgress?.items?.[p.sku];
          if (progress && Number.isInteger(progress.count) && progress.count >= 0 && Number.isInteger(progress.available) && progress.available >= 0) {
            const purchased=progress.count % 36;
            const label=progress.available > 0 ? this.copy.testerAvailable.replace('__COUNT__',String(progress.available)) : purchased >= 30 ? this.copy.testerNear.replace('__REMAINING__',String(36-purchased)) : this.copy.testerProgress.replace('__COUNT__',String(purchased));
            body.append(this.el('div','bg-qo__tester-progress',label));
          }
          product.append(body);row.append(product);
          row.append(this.el('span','bg-qo__price',p.price>0?this.money(p.price):this.copy.unpriced));
          const availability = p.preorder ? this.copy.preorder.replace('__DATES__', this.preorderDates()) : p.stock > 0 ? '' : this.copy.unavailable;
          row.append(this.el('span','bg-qo__inventory'+(p.stock || p.preorder ? '' : ' empty'),availability));
          const qty=this.el('div','bg-qo__qty'),minus=this.el('button','', '−'),input=this.el('input'),plus=this.el('button','', '+');
          input.type='number';input.min='0';if(!p.preorder)input.max=String(p.stock);input.step='1';input.inputMode='numeric';input.value=this.quantities.get(p.id)||0;input.setAttribute('aria-label',this.copy.quantity+' — '+p.title);
          [minus,plus].forEach(b=>b.type='button');minus.setAttribute('aria-label',this.copy.less+' — '+p.title);plus.setAttribute('aria-label',this.copy.more+' — '+p.title);
          const disabled=(!p.preorder && p.stock<3)||p.price<=0;input.disabled=disabled;minus.disabled=disabled;plus.disabled=disabled;qty.append(minus,input,plus);row.append(qty);
          const line=this.el('span','bg-qo__line',this.money(p.price*(this.quantities.get(p.id)||0)));row.append(line);
          const update=value=>{const requested=Math.floor(Number(value)||0);const capped=p.preorder?requested:Math.min(p.stock,requested);const n=capped<=0?0:Math.max(3,capped);input.value=n;n?this.quantities.set(p.id,n):this.quantities.delete(p.id);line.textContent=this.money(n*p.price);this.summary();};
          minus.addEventListener('click',()=>update(Number(input.value)<=3?0:Number(input.value)-1));plus.addEventListener('click',()=>update(Number(input.value)===0?3:Number(input.value)+1));input.addEventListener('change',()=>update(input.value));
          rows.append(row);
        });
        this.querySelector('[data-prev]').disabled=this.page<=1;this.querySelector('[data-next]').disabled=this.page>=this.pages;this.querySelector('[data-page]').textContent=this.page+' / '+this.pages;this.summary();
      }
      testerCount(total){if(this.initialPlacementUsed)return 0;if(total>=199900)return 10;if(total>=99900)return 5;if(total>=49900)return 3;return 0;}
      preorderDates(){const format=new Intl.DateTimeFormat('el-GR',{day:'numeric',month:'short',year:'numeric'});const from=new Date(),to=new Date();from.setDate(from.getDate()+7);to.setDate(to.getDate()+10);return format.format(from)+' – '+format.format(to);}
      summary(){let total=0,count=0;this.catalog.forEach(p=>{const n=this.quantities.get(p.id)||0;total+=p.price*n;count+=n;});this.querySelector('[data-count]').textContent=String(count);this.querySelector('[data-total]').textContent=this.money(total);const belowMinimum=total<25000;this.querySelector('[data-add]').disabled=this.busy||!this.catalogLoaded||!count||belowMinimum||this.dataset.enabled!=='true';const minimum=this.querySelector('[data-minimum]');minimum.hidden=!count||!belowMinimum;if(!minimum.hidden)minimum.textContent=this.copy.minimum.replace('__AMOUNT__',this.money(25000-total));const status=this.querySelector('[data-custom-status]');if(status&&this.package==='custom'){const testers=this.testerCount(total);if(this.initialPlacementUsed){status.textContent=this.copy.repeatTesterRule;}else if(belowMinimum){status.textContent=this.copy.customMinimum.replace('__AMOUNT__',this.money(25000-total));}else if(testers===10){status.textContent=this.copy.customTesters10;}else if(testers===5){status.textContent=this.copy.customTesters5;}else if(testers===3){status.textContent=this.copy.customTesters3;}else{status.textContent=this.copy.customNoTesters;}}}
      async add(){
        let currentTotal=0;this.catalog.forEach(p=>{currentTotal+=p.price*(this.quantities.get(p.id)||0);});
        if(this.busy||!this.quantities.size||this.dataset.enabled!=='true'||currentTotal<25000)return;
        this.busy=true;this.summary();const message=this.querySelector('[data-message]');message.textContent=this.copy.pending;this.querySelector('[data-cart]').hidden=true;
        try{
          const selected=this.catalog.filter(p=>this.quantities.has(p.id));const items=[];let changed=false;
          for(const p of selected){
            const response=await fetch(this.dataset.root+'products/'+encodeURIComponent(p.handle)+'.js',{headers:{Accept:'application/json'}});
            if(!response.ok)throw new Error(this.copy.soon);
            const live=await response.json();const variant=live.variants.find(v=>String(v.id)===p.id);const quantity=this.quantities.get(p.id);
            if(!variant||!variant.available||quantity<3||variant.inventory_management&&variant.inventory_policy==='deny'&&variant.inventory_quantity<quantity)throw new Error(this.copy.changed);
            if(Number(variant.price)!==p.price){p.price=Number(variant.price);changed=true;}
            items.push({id:Number(p.id),quantity});
          }
          if(changed){this.render();throw new Error(this.copy.changed);}
          const testerCount=this.testerCount(currentTotal);
          const cartAttributes=this.package?{beautygram_initial_placement:this.initialPlacementUsed?'':'true',beautygram_package:this.package,beautygram_tester_entitlement:String(testerCount)}:{beautygram_initial_placement:'',beautygram_package:'',beautygram_tester_entitlement:''};
          const attributeResponse=await fetch(this.dataset.root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:cartAttributes})});
          if(!attributeResponse.ok)throw new Error(this.copy.failed);
          const response=await fetch(this.dataset.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
          const result=await response.json();
          if(!response.ok)throw new Error(result.description||this.copy.failed);
          this.quantities.clear();this.render();message.textContent=this.copy.success;this.querySelector('[data-cart]').hidden=false;
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        }catch(error){message.textContent=error.message||this.copy.failed;this.querySelector('[data-cart]').hidden=false;}
        finally{this.busy=false;this.summary();}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
